

import * as Highcharts from 'highcharts';
import 'highcharts/modules/exporting';
import 'highcharts/modules/offline-exporting';
import 'highcharts/modules/drilldown';
import 'highcharts/modules/accessibility';
import 'highcharts/modules/annotations';
import 'highcharts/modules/export-data';



import GroupedCategories from "highcharts-grouped-categories";
GroupedCategories(Highcharts);



export { Highcharts };
